import { ChangeDetectionStrategy, Component, Input, TemplateRef } from "@angular/core";
import { NzRibbonComponent } from "ng-zorro-antd/badge";
import { NzOutletModule } from "ng-zorro-antd/core/outlet";

@Component({
  selector: "ui-ribbon",
  exportAs: "uiRibbon",
  templateUrl: "./ribbon.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NzOutletModule],
})
export class UiRibbonComponent extends NzRibbonComponent {
  @Input("uiColor") public nzColor: string | undefined;
  @Input("uiPlacement") public nzPlacement: "start" | "end" = "end";
  @Input("uiText") public nzText: string | TemplateRef<void> | null = null;
}
